import { UI, TextTypes } from '@genial/components';
import { ColorTypes } from '@genial/design-tokens';
import React from 'react';

export interface ColorCodedTextProps {
  sign: 'positive' | 'negative' | 'neutral';
  text: string;
  textProps?: Omit<TextTypes.Props, 'color'>;
}

export const ColorCodedText: React.FC<ColorCodedTextProps> = ({ sign, text, textProps }) => {
  const getCodedColor = (): ColorTypes.Option => {
    switch (sign) {
      case 'positive':
        return 'feedback.success.default';

      case 'negative':
        return 'feedback.error.default';

      case 'neutral':
        return 'neutral.medium';
    }
  };

  return (
    <UI.Text {...textProps} color={getCodedColor()}>
      {text}
    </UI.Text>
  );
};
